module.exports = __webpack_public_path__ + "Roboto-RegularItalic.90dbf902b8d0592e1beb.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.ttf
// module id = 147
// module chunks = 16